module.exports = __webpack_public_path__ + "static/media/焼き鳥TAKU.42fb2dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/store/焼き鳥TAKU.png
// module id = 339
// module chunks = 10